<template>
    <el-form size="small">
        <el-form-item label="Marcas:" class="select-marca">
            <el-select class="d-inline-block w-100" size="small" v-model="computedMarca" filterable multiple>
                <el-option
                    v-for="item in listaMarcas"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    name: 'selectMarcas',
    props: {
      value: {
        type: Array,
        default: []
      },
      notStorage: {
        type: Boolean,
        default: false
      }
    },
    data() {
        return {
            listaMarcas: this.getMarcas(),
        }
    },
    computed: {
        computedMarca: {
            get() {
                return this.value ? this.value.map(String).slice() : [];
            },
            set(newVal) {
                this.$emit('input', newVal);

                if (!newVal.length) {
                    this.$emit('input', []);
                }

                if (newVal.length > 1) {
                    if (newVal.includes('0') && newVal[0] === '0') {
                        this.$emit('input', newVal.filter(id => id !== '0'));
                    } else if (newVal.includes('0')) {
                        this.$emit('input', ['0']);
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss">
.select-marca {
    .el-form-item__label {
        line-height: 22px !important;
    }
}
</style>